"use client";

import { useSearchParams, usePathname } from "next/navigation";
import { clearFalsyKeysFromObject } from "@/utils/global";

const Index = () => {
  const searchParams = useSearchParams();
  const pathname = usePathname();

  // Convert searchParams to an object
  const getFilterObj = Object.fromEntries(searchParams.entries());

  const setFilterQueryHandler = (obj) => {
    const updatedParams = new URLSearchParams(getFilterObj);

    // Update the query object with new values
    Object.entries(obj).forEach(([key, value]) => {
      if (value) {
        updatedParams.set(key, value);
      } else {
        updatedParams.delete(key);
      }
    });

    const modifiedObj = clearFalsyKeysFromObject(
      Object.fromEntries(updatedParams.entries())
    );

    // Update the URL without causing a re-render or revalidation
    window.history.replaceState(null, "", `${pathname}?${new URLSearchParams(modifiedObj).toString()}`);
  };

  const resetFilterQueryHandler = () => {
    // Reset the query parameters without triggering a revalidation
    window.history.replaceState(null, "", pathname);
  };

  return {
    getFilterObj,
    setFilterQueryHandler,
    resetFilterQueryHandler,
  };
};

export default Index;
